import { Injectable } from "@angular/core";
import { Theme, light, dark } from "./theme";
import { Observable, BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class ThemeService {
    private active: Theme = light;
    private availableThemes: Theme[] = [light, dark];
    public themeIsDark: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false); // poc

    // poc: header must be aware of what the current theme is to be able to switch between more than 2 themes
    public currentTheme: BehaviorSubject<string> = new BehaviorSubject<string>("light"); 

    constructor() {
        if (this.active.name === dark.name)
            this.themeIsDark.next(true);
        else
            this.themeIsDark.next(false);
        // Set the current theme
        this.currentTheme.next(this.getActiveTheme().name);

    }


    getAvailableThemes(): Theme[] {
        return this.availableThemes;
    }

    getActiveTheme(): Theme {
        return this.active;
    }

    isDarkTheme(): boolean {
        return this.active.name === dark.name;
    }
    getThemeName(): string {
        return this.active.name;
    }

    setDarkTheme(): void {
        this.setActiveTheme(dark);
        this.themeIsDark.next(true); // poc
    }

    setLightTheme(): void {
        this.setActiveTheme(light);
        this.themeIsDark.next(false); // poc
    }



    setActiveTheme(theme: Theme): void {
        this.active = theme;

        // POC
        this.currentTheme.next(theme.name);

        Object.keys(this.active.properties).forEach(property => {
            document.documentElement.style.setProperty(
                property,
                this.active.properties[property]
            );
        });
    }



}
